export default __webpack_public_path__ + "static/8-5503d9389811c691a57676b39952c8ce.jpg";